import React, { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../AbstractElements";
import HeaderCard from "../../Common/HeaderCard";
import { scrollpara, scrollpara1, scrollpara2, scrollpara3 } from "../../../Constant";
import ScrollBar from "react-perfect-scrollbar";

const VerticalScroll = () => {
  return (
    <Fragment>
      <Col sm="6">
        <Card>
          <HeaderCard title="Vertical Scroll" />
          <CardBody>
            <ScrollBar className="vertical-scroll scroll-demo" style={{ width: "100%", height: 300 }}>
              <P>{scrollpara}</P>
              <P>{scrollpara1}</P>
              <P>{scrollpara2}</P>
              <P>{scrollpara1}</P>
              <P>{scrollpara3}</P>
            </ScrollBar>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default VerticalScroll;
